import React from "react";
import { Box, Button, Chip, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import dayjs from "dayjs";
import { formatNumberAmount } from "../../helpers/format";
import ShadowBox from "../layout/container/ShadowBox";
import SimpleBox from "../layout/container/SimpleBox";

// Mirrors the card layout used in the payment-reference/unpaid-summary emails
// (mail/templates/payment_reference.html, unpaid_summary.html): a person-name
// badge, entity/reference + bold amount, and a pink "Pagar com MBWAY" pill
// linking to the exact same /mbway/:id flow the emails use.
const MBWAY_COLOR = "#e4067e";

const PaymentReferenceItem = ({ reference }) => {

    const theme = useTheme();
    const navigate = useNavigate();

    const formattedDescription = Boolean(reference.description) ? reference.description.split('\n').map((line, iline) => {
        return <Box fontSize="0.8em" key={iline}>{line}</Box>
    }) : null;

    return (
        <ShadowBox width="100%" height="100%">
            <SimpleBox fullWidth={true} justifyContent="space-between" alignItems="center">
                <Chip
                    size="small"
                    label={reference.person.name}
                    sx={{
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        fontWeight: "bold",
                        fontSize: "0.7rem",
                    }}
                />
                <Typography fontSize="0.75em" color={theme.palette.text.secondary}>
                    {dayjs(reference.timestamp).format("YYYY-MM-DD")}
                </Typography>
            </SimpleBox>

            {formattedDescription ? (
                <Box mt={theme.spacing(2)}>{formattedDescription}</Box>
            ) : null}

            <SimpleBox fullWidth={true} justifyContent="space-between" alignItems="center" mt={theme.spacing(2)}>
                <Box>
                    <Typography fontSize="0.8rem" color={theme.palette.text.secondary}>
                        Entidade <b style={{ color: theme.palette.text.primary }}>{reference.entity}</b>
                    </Typography>
                    <Typography fontSize="0.8rem" color={theme.palette.text.secondary}>
                        Referência <b style={{ color: theme.palette.text.primary }}>{reference.reference}</b>
                    </Typography>
                </Box>
                <Typography fontWeight="bold" color="primary">
                    {formatNumberAmount(reference.amount)}
                </Typography>
            </SimpleBox>

            <Box mt={theme.spacing(3)} textAlign="center">
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/mbway/${reference.id}`)}
                    sx={{
                        backgroundColor: MBWAY_COLOR,
                        borderRadius: "20px",
                        "&:hover": { backgroundColor: MBWAY_COLOR, opacity: 0.9 },
                    }}
                >
                    Pagar com MBWAY
                </Button>
            </Box>
        </ShadowBox>
    )
}

export default PaymentReferenceItem;
